module.exports = __webpack_public_path__ + "img/hp-knife-ruby.2eda68b7.png";